import blockFetcher from './block-fetcher';

export default {
  blockFetcher,
};
